// The picture of a shape with curves: half a circle, a quarter of a circle,
// a rectangle with half a circle on one side, or a running track, with
// labels along its sides. Plain React SVG, like practice-shape.tsx.
//
// A dashed line crosses each join of a half circle and straight sides, the
// way a school book draws them.

import {
  CURVED_LABEL_SIZE,
  CURVED_NOTE_SIZE,
  curvedShapePicture,
  describeCurvedShape,
  type CurvedShapeSpec,
} from './practice-curved-shape-data';

const INK = '#2d4a3e';
const SHAPE_FILL = '#eef3ee';

const fixed = (value: number) => value.toFixed(2);

export function CurvedShapeView({ shape }: { shape: CurvedShapeSpec }) {
  const picture = curvedShapePicture(shape);
  const { box } = picture;

  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeCurvedShape(shape)}
        viewBox={`${fixed(box.x)} ${fixed(box.y)} ${fixed(box.width)} ${fixed(box.height)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(box.width * 1.4))}px` }}
      >
        <path
          data-outline="true"
          d={picture.outline}
          fill={SHAPE_FILL}
          stroke={INK}
          strokeWidth="2.2"
          strokeLinejoin="round"
        />
        {picture.dashes.map((dash, index) => (
          <line
            key={index}
            data-mark="join"
            x1={fixed(dash.from.x)}
            y1={fixed(dash.from.y)}
            x2={fixed(dash.to.x)}
            y2={fixed(dash.to.y)}
            stroke={INK}
            strokeWidth="1.6"
            strokeDasharray="5 4"
          />
        ))}
        {picture.texts.map((text, index) => (
          <text
            key={index}
            data-label={text.place}
            x={fixed(text.x)}
            y={fixed(text.y)}
            dy="0.35em"
            textAnchor="middle"
            fill={INK}
            fontSize={
              text.place === 'scale' ? CURVED_NOTE_SIZE : CURVED_LABEL_SIZE
            }
            fontWeight={text.place === 'scale' ? '400' : '700'}
            fontStyle={text.place === 'scale' ? 'italic' : undefined}
          >
            {text.text}
          </text>
        ))}
      </svg>
    </figure>
  );
}
